import React from 'react';
import Party from "../../model/Party";
import Backend from "../../backend/Backend";
import {selectedCompanyStore} from "../../store/SelectedCompany";
import LoaderWithCompanySelected from "../../components/LoaderWithCompanySelected";
import MyMaterialTable from "../../components/mtable/MyMaterialTable";

interface IProps {
}

interface IState {
    customers: Party[],
    loading: boolean,
    error: boolean
}

class PartyList extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            customers: [],
            loading: true,
            error: false,

        };
    }

    async componentDidMount() {
        if (selectedCompanyStore.isSelected) {
            const selectedCompanyId = selectedCompanyStore.companyId;
            await Backend.get(`/api/v1/company/${selectedCompanyId}/parties`)
                .then(response => {
                        this.setState({
                            customers: response,
                            loading: false
                        })
                    }
                )
                .catch(() => this.setState({
                    loading: false,
                    error: true
                }));
        }
    }

    render() {
        const {customers, loading, error} = this.state;

        return (
            <LoaderWithCompanySelected loading={loading} error={error}>
                <MyMaterialTable
                    title="Customers & Vendors"
                    columns={[
                        {title: 'ID', field: 'id',},
                        {title: 'Name', field: 'name',},
                        {title: 'Type', field: 'type'},
                    ]}
                    data={customers}
                    options={{
                        search: true,
                        sorting: false,
                        paging: false,
                        draggable: false,
                    }}
                />
            </LoaderWithCompanySelected>
        );
    }
}

export default PartyList;